import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DEAL_STATUS_DISPLAY_;

export var DEAL_STATUS = {
  QUOTE: 'QUOTE',
  FINANCE_AND_INSURANCE: 'FINANCE_AND_INSURANCE',
  FUNDS_PENDING: 'FUNDS_PENDING',
  RECAP: 'RECAP',
  DOCS_SIGNING: 'DOCS_SIGNING',
  DOCS_PRINTED: 'DOCS_PRINTED',
  BOOKED: 'BOOKED',
  LOST: 'LOST',
  CREDIT_APPROVED: 'CREDIT_APPROVED',
  CLOSED_OR_SOLD: 'CLOSED_OR_SOLD',
  UNWIND: 'UNWIND',
  PREORDER: 'PREORDER',
  PRE_CLOSED: 'PRE_CLOSED',
  CONFIRMED: 'CONFIRMED'
};
export var DEAL_STATUS_DISPLAY_MAP = (_DEAL_STATUS_DISPLAY_ = {}, _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.QUOTE, __('Quote')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.FINANCE_AND_INSURANCE, __('In F&I')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.RECAP, __('In Recap')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.DOCS_SIGNING, __('Docs Signing')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.DOCS_PRINTED, __('Docs Printed')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.BOOKED, __('Booked')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.LOST, __('Lost')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.CREDIT_APPROVED, __('CREDIT_APPROVED')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.CLOSED_OR_SOLD, __('Closed or Sold')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.UNWIND, __('Unwound')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.PREORDER, __('Pre Order')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.PRE_CLOSED, __('Pre-closed')), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.CONFIRMED, __('Confirmed')), _DEAL_STATUS_DISPLAY_);
export var DEAL_STATUS_FILTERS = [{
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.QUOTE],
  value: DEAL_STATUS.QUOTE
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.FINANCE_AND_INSURANCE],
  value: DEAL_STATUS.FINANCE_AND_INSURANCE
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.RECAP],
  value: DEAL_STATUS.RECAP
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.DOCS_SIGNING],
  value: DEAL_STATUS.DOCS_SIGNING
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.BOOKED],
  value: DEAL_STATUS.BOOKED
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.CLOSED_OR_SOLD],
  value: DEAL_STATUS.CLOSED_OR_SOLD
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.LOST],
  value: DEAL_STATUS.LOST
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.DOCS_PRINTED],
  value: DEAL_STATUS.DOCS_PRINTED
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.UNWIND],
  value: DEAL_STATUS.UNWIND
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.PREORDER],
  value: DEAL_STATUS.PREORDER
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.PRE_CLOSED],
  value: DEAL_STATUS.PRE_CLOSED
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.CONFIRMED],
  value: DEAL_STATUS.CONFIRMED
}];